import React, { ReactElement } from 'react';
import styled from 'styled-components';

import { Flex } from 'components';

import { TypesItems } from './types';
import useAlert from './useAlert';

const Wrapper = styled(Flex)<{ type: TypesItems }>`
  color: ${({ type, theme, ...props }) =>
    (props as any)['data-invert']
      ? type === 'error'
        ? theme.colors.alert_400
        : type === 'success'
        ? theme.colors.success_400
        : type === 'warning'
        ? theme.colors.warning_400
        : 'white'
      : 'white'};

  a {
    color: ${({ type, theme, ...props }) =>
      (props as any)['data-invert']
        ? type === 'error'
          ? theme.colors.alert_400
          : type === 'success'
          ? theme.colors.success_400
          : type === 'warning'
          ? theme.colors.warning_400
          : 'white'
        : 'white'};
    text-decoration: underline;
  }

  background: ${({ type, theme, ...props }) => {
    if ((props as any)['data-invert']) {
      return 'transparent';
    }

    if (type === 'error') {
      return theme.colors.alert_400;
    }

    if (type === 'success') {
      return theme.colors.success_400;
    }

    if (type === 'warning') {
      return theme.colors.warning_400;
    }

    return 'transparent';
  }};

  ${({ theme: { mediaQueries } }) => {
    return `
      font-size: 0.875rem;

      ${mediaQueries.desktop} {
        font-size: 1rem;
      }
    `;
  }}
`;

const createMarkup = (encodedHtml: string) => ({
  __html: encodedHtml,
});

interface AlertProps {
  px?: number | { m?: number | string; t?: number | string; d?: number | string };
  py?: number | { m?: number | string; t?: number | string; d?: number | string };
  invert?: boolean;
  style?: any;
}

const Alert = ({ py = { m: 20, d: 30 }, px = { m: 20, d: 30 }, style, invert = false }: AlertProps): ReactElement => {
  const {
    alert: { type, message },
  } = useAlert();

  return message ? (
    <Wrapper flexGrow={0} px={px} py={py} type={type} data-invert={invert} style={style}>
      <div dangerouslySetInnerHTML={createMarkup(message)} />
    </Wrapper>
  ) : (
    <></>
  );
};
export default React.memo(Alert);
